<template>
  <div v-cloak>
    <div ref="imageDom">
      <div class="header syTitle acea-row row-center-wrapper">
            {{title}}
      </div>
      <div class="detailView row-center-wrapper syDetail">{{detail}}</div>

      <div class="acea-row row-center-wrapper codeView1">价格：{{price}}元</div>
      <div class="acea-row row-center-wrapper codeView">扫码缴费</div>
      <div class="item acea-row row-between-wrapper">
          <div class="pictrue imageView">
            <img :src="codeUrl" class="imageStyle" />
          </div>
      </div>
    </div>
    
    <div class="acea-row row-center-wrapper buttonViewCode1">点击下方生成分享图片或者点击右上角分享</div>
    <van-button type="default" @click="saveImg" class="buttonViewCode">生成分享图片</van-button>
    

    <van-popup v-model="show" class="popupImgView">
      <div class="acea-row row-center-wrapper buttonViewCode1">可长按分享或者保存分享图片</div>
      <img :src="shareImage" class="shareImageStyle" />
    </van-popup>
  </div>
</template>
<style>
.popupImgView {
  width: 88%;
  height: 88%;
  margin-top: 10px;
}
.lineView {
  height: 10px;
}
.buttonViewCode1 {
  margin-top: 4px;
}
.buttonViewCode {
  margin-top: 10px;
  margin-left: 10%;
  width: 80%;
  background-color:#2EBCBF;
  color: white;
}
.codeView1 {
  color: red;
  margin-top: 4px;
  margin-bottom: -20px;
}
.codeView {
  margin-top: 20px;
  margin-bottom: -20px;
}
.detailView {
  margin: 10px;
  color: #000000;
  font-size: 10px;
  display: flex;
  justify-content: center;
  border-radius:10px;
}
.imageView {
  width: 66%;
  height: 66%;
  margin-left: 17%;
  margin-top: 30px;
  /* background-color: #e93323;
  color: #fff;
  font-size: 20px; */
  /* display: flex;
  justify-content: center;
  border-radius:10px; */
}
.syTitle {
  margin-top: 10px;
  /* background-color: #e93323; */
  color: #000000;
  font-size: 20px;
}
.syDetail {
    font-size: 14px;
}
.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
.footer .icon-shoucang1 {
  color: #e93323;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.imageStyle {
  margin-left: 10%; 
  width: 80%;
  height: 80%;
  overflow: hidden;
}
.shareImageStyle {
  width: 100%;
  height: 78%;
  overflow: hidden;
}
</style>
<script>
import {
  getRecommend
} from "@api/public";
import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";
import { log } from 'util';
import { Toast } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';

import { Loading } from 'vant';
import { Field } from 'vant';
import { Button } from 'vant';

import cookie from "@utils/store/cookie";

import { parseQuery } from "@utils/index";

import html2canvas from "html2canvas";

import { Popup } from 'vant';

import { openShareAppMessage, openShareTimeline, ready } from "@libs/wechat";

export default {
  name: "GoodsCon",
  components: {
    [Popup.name]:Popup,
    [Loading.name]:Loading,
    [Field.name]:Field,
    [Button.name]:Button,
    Toast
  },
  data: function() {
    return {
      price:'',
      shareImage:'',
      show: false,
      codeUrl: "",
      checked: true,
      title: "",
      detail: "",
    };
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {

    let that = this;

    this.productId = this.$route.params.productId;
    // this.unionId = 'ojHwQv8zV_OfXT5-wA0TZ26YeFmA';
    // this.unionId = cookie.get("lishu-openid");
    this.url = "http://datum.lishuedu.com/buyDetail/";

    log('productId is '+this.productId);

    let param = parseQuery();

    if (param.unionid != null) {
      this.unionId = param.unionid;
    }else{
      this.unionId = null;
    }
    
    // that.$dialog.confirm({
    //           mes: "unionId--"+that.unionId+"--productId--"+that.productId,
    //           opts: [
    //             {
    //               txt: "确认",
    //               color: false,
    //               callback: () => {
    //               }
    //             }
    //           ]
    //           });

    // Toast.loading({
    //   message: '加载中...',
    //   forbidClick: true
    // });
    if (this.unionId) {
      this.productCon();
    }else{
      that.$dialog.toast({ mes: "openid 网络异常!!" });
    }
    // this.jssdkReady = cookie.get("jssdkReady");

    // if (this.jssdkReady == 1) {
    //   this.setOpenShare();
    // }
      // this.setOpenShare();
  },

  methods: {
    setOpenShare: function() {

      log("setOpenShare -- ");
        var configAppMessage = {
          desc: this.title,
          title: '二维码分享',
          link: location.href,
          imgUrl: 'http://datum.lishuedu.com/share.png'
        };
        var configTimeline = {
          title: '二维码分享',
          link: location.href,
          imgUrl:'http://datum.lishuedu.com/share.png'
        };
        if (isWeixin() === true) {
          ready().then(() => {
            openShareAppMessage(configAppMessage).then(() => {});
            openShareTimeline(configTimeline).then(() => {});
          });
        }
    },
    saveImg: function() {
      log("saveImg");
      html2canvas(this.$refs.imageDom).then(canvas => {
        // 转成图片，生成图片地址
        this.imgUrl = canvas.toDataURL("image/png");
        log(this.imgUrl);
        this.shareImage = this.imgUrl;
        this.show = true;
      });
    },
    //产品详情接口；
    productCon: function() {
      let that = this;

      getRecommend(that.productId, that.unionId, that.url)
        .then((data, res) => {
          log("res.data");
          log(data);
          if (data.code == 301) {
              that.$dialog.error(data.msg);
          }else{
            that.$set(that, "codeUrl", data.data.qrCode);
            that.$set(that, "title", data.data.name);
            that.$set(that, "detail", data.data.desc);
            that.$set(that, "price", data.data.price);
          }
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
    },
  }
};
</script>
